import CLOUDFRONT_QUERY_SIGNATURE_QUERY from '@/shared/api/queries/cloudFrontQuerySignature';
import type {
  CloudFrontQuerySignatureQuery,
  CloudFrontQuerySignatureQueryVariables,
} from '@/shared/api/generated/graphql';
import createClient from '../client/apolloClient';

export type CloudFrontQuerySignatureResult = {
  isSuccess: boolean;
  message: string;
  cloudFrontQuerySignature: string;
};

// TODO(ts): typed as the CloudFrontQuerySignatureFilter GraphQL input once its server-side shape is documented
/**
 * Obtains a signed CloudFront query string for fetching protected media. Runs the signature query and returns the signature on success, throwing the server message otherwise.
 *
 * @param filter - Query filter naming the resource to sign for.
 * @returns A promise resolving to the CloudFront query signature.
 */
const fetchQuerySignature = async (filter: any) => {
  const client = await createClient();
  const result = await client.query<
    CloudFrontQuerySignatureQuery,
    CloudFrontQuerySignatureQueryVariables
  >({
    query: CLOUDFRONT_QUERY_SIGNATURE_QUERY,
    variables: {
      filter,
    },
  });
  const { data } = result;
  const { cloudFrontQuerySignature } = data;
  if (cloudFrontQuerySignature?.isSuccess) {
    return cloudFrontQuerySignature?.cloudFrontQuerySignature;
  }
  throw new Error(cloudFrontQuerySignature.message);
};

export default fetchQuerySignature;
